/** Query stringovi za liste veleprodaje. Prazne vrijednosti ispadaju da URL ostane čitljiv
 *  i da React Query ključ za "bez filtera" bude uvijek isti. */
export function wholesaleQuery(params: Record<string, string | number | null | undefined | string[]>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    // Lista se ponavlja kao `k=a&k=b` — server je čita sa `searchParams.getAll`, pa
    // višestruki izbor (kategorije) ne mora izmišljati vlastiti separator.
    if (Array.isArray(v)) {
      for (const item of v) {
        const s = String(item ?? "").trim();
        if (s) sp.append(k, s);
      }
      continue;
    }
    const s = v === null || v === undefined ? "" : String(v).trim();
    if (s) sp.set(k, s);
  }
  return sp.toString();
}

export function orderListQuery(f: { status?: string; partnerId?: string; search?: string }): string {
  return wholesaleQuery({ status: f.status, partnerId: f.partnerId, search: f.search });
}

/** Escape za SQL LIKE uzorak: `%`, `_` i `\\` u pojmu pretrage postaju doslovni znakovi.
 *  Klauzula mora nositi `ESCAPE '\\'`, vidi `LIKE_ESCAPE`. */
export function escapeLike(term: string): string {
  return term.replace(/[\\%_]/g, (c) => `\\${c}`);
}
/** SQL sufiks uz `LIKE ?` kad je vrijednost prošla kroz `escapeLike`. U MySQL literalu je
 *  backslash i sam escape znak, pa SQL tekst glasi `ESCAPE '\\'` (literal s jednim backslashom). */
export const LIKE_ESCAPE = "ESCAPE '\\\\'";
